<template>
  <div
    v-if="data.isLoggedIn"
    ref="avatar"
    class="avatar avatar--wrapper"
    @keydown.esc="closeOnEsc"
  >
    <div
      class="avatar-truncate-button-wrapper"
    >
      <span
        v-if="totalNotification > 0 && data.isLoggedIn "
        class="badge badge--button-position arrow-drowdown__badges"
      >{{ totalNotification }}</span>
      <button
        type="button"
        aria-label="Mina tjänster"
        aria-haspopup="true"
        :class="{
          'active': active,
          'mini-avatar': this.$root.currentSizeLte('xs')
        }"
        class="button--secondary button--32 button--text-icon avatar__dropdown truncate-text"
        @click.prevent="toggleAvatar"
      >
        <svgicon
          name="Users/User"
          class="avatar__icon-user"
        />{{ customerName }}
        <span
          v-if="this.$root.currentSizeGte('sm')"
          class="avatar-icon-wrapper"
        >
          <svgicon
            :name="toggleArrow"
            class="avatar--icon-arrow"
          />
        </span>
      </button>
    </div>
    <div
      v-if="active"
      class="active avatar-dropdown-placeholder"
    >
      <div class="avatar-dropdown-placeholder__top-header">
        <h2 class="font-rubrik-1--bold avatar-dropdown-placeholder__heading">
          Mitt ICA
        </h2>
        <svgicon
          name="Controls/Close"
          class="avatar--icon-close"
          @click="toggleAvatar"
        />
      </div>
      <template v-if="data.bonusDetails && data.isLoggedIn">
        <div class="avatar-dropdown-placeholder__header">
          <span
            class="avatar-dropdown-placeholder__mini-bonus"
          >Min bonus</span>

          <div class="progress-bar progress-bar--wrapper">
            <div
              class="progress-bar progress-bar__filled"
              :style="`width: ${100 * data.bonusDetails.currentPoints / data.bonusDetails.nextLevelPoints}%;`"
            >
              &nbsp;
            </div>
          </div>
          <div class="avatar-dropdown-placeholder__discount-info">
            {{ data.bonusDetails.currentBonus }}kr i bonuscheckar
          </div>
          <span class="avatar-dropdown-placeholder__remaining-points">{{ data.bonusDetails.nextLevelPoints - data.bonusDetails.currentPoints }}p till nästa nivo ({{ data.bonusDetails.nextBonus }}kr)</span>
        </div>
      </template>
      <template v-else-if="!data.isLoggedIn">
        <div class="avatar-dropdown-placeholder__header">
          <p
            class="avatar-dropdown-placeholder__loginstate-text-info"
          >
            Logga in för att se dina bonuscheckar
          </p>
        </div>
      </template>
      <div class="avatar-dropdown-placeholder__body row">
        <template v-for="(link, index) in data.links">
          <a
            :key="link + index"
            :href="link.url"
            class="avatar-dropdown-placeholder__link-icons col-4"
            @click="avatarMenuClick(link.text)"
          >

            <div class="avatar-dropdown-placeholder__icon-wrapper">
              <svgicon
                :name="link.iconUrl"
              />
              <template v-if="data.isLoggedIn">
                <span
                  v-if="link.notification"
                  class="badge badge--icon-position-up-right"
                  v-text="link.notification"
                />
              </template>
              <template v-else-if="link.loginRequired">
                <svgicon
                  name="Controls/Locked"
                  class="avatar-dropdown-placeholder__lock-icon"
                />
              </template>
            </div>
            <template>
              <span
                class="avatar-dropdown-placeholder__text"
                v-text="link.text"
              />
            </template>
          </a>
        </template>
      </div>
      <div class="avatar-dropdown-placeholder__footer">
        <template v-if="data.isLoggedIn">
          <button
            id="js-logout"
            class="avatar-dropdown-placeholder__logout-user button--secondary button--48 button--fullwidth"
            type="button"
            @click.prevent="logout"
          >
            Logga ut
          </button>
        </template>
        <template v-else>
          <button
            type="button"
            class="avatar-dropdown-placeholder__logout-user button--primary button--48 button--fullwidth"
          >
            Logga in
          </button>
          <a
            href="#"
            class="button--transparent button--48 button--fullwidth"
          >Bli ICA-bonuskund </a>
        </template>
      </div>
    </div>
  </div>
  <button
    v-else
    type="button"
    :class="{
      'button--icon': this.$root.currentSizeEquals('xxs'),
      'button--text-icon': this.$root.currentSizeGte('xs')}"
    class="button--32 login"
    @click="handleLoginClick"
  >
    <svgicon
      name="Users/User"
      class="avatar__icon-user"
    />Logga in
  </button>
</template>
<script>
import ga from '@/analytics/dataLayerTopNav.js'

export default {
  name: "Avatar",
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      active: false,
      track: ga
    }
  },
  computed: {
    customerName () {
      if (this.$root.currentSizeGte('sm')) {
        return this.data.customer.name
      } else {
        return this.data.customer.name.substr(0, 1)
      }
    },
    toggleArrow () {
      return this.active ? "Navigation/AngleUp" : "Navigation/AngleDown"
    },
    totalNotification () {
      let total = 0
      let filteredNotification = this.data.links.filter(filter => filter.notification)
      filteredNotification.forEach((item) => {
        let { notification } = item
          total += notification
      })
      return total
    },
  },
  created () {
    if (!SSR_MODE) {
      document.addEventListener("click", this.documentClick)
    }
  },
  destroyed () {
    if (!SSR_MODE) {
      document.removeEventListener("click", this.documentClick)
    }
  },
  methods: {
    logout () {
      if (window && window.epi6logout) {
        // epi6 logout only
        window.epi6logout()
      } else {
        const returnUrl = encodeURIComponent(window.location.href)
        window.location = `${window.location.origin}/e11/sign-out/?returnUrl=${returnUrl}`
      }
    },
    handleLoginClick () {
      if (window.icaseUserLogin) {
        window.icaseUserLogin()
      }
    },
    toggleAvatar () {
      this.active = !this.active
    },
    avatarMenuClick (text) {
      this.track.avatarMenuClick(text)
      this.toggleAvatar()
    },
    closeOnEsc () {
      this.active = false
    },
    documentClick (e) {
      let el = this.$refs.avatar
      let target = e.target

      if (!el) return

      if ((el !== target && !el.contains(target)) || target.tagName === 'A') {
        this.active = false
      }
    }
  },
}
</script>
<style lang="scss">
.avatar {
  @media (min-width: 30em) {
    .header-navigation-wrapper:not(.ie11) & {
      max-width: calc(100% - 10rem);
    }

    .header-navigation-wrapper:not(.ie11) .no-search & {
      max-width: calc(100% - 8rem);
    }
  }

  .header-navigation-wrapper:not(.ie11) .no-ecommerce & {
    max-width: 100%;
  }

  .avatar-truncate-button-wrapper {
    flex-shrink: 1;
    margin-left: auto;
    position: relative;

    .login {
      padding: 0.375rem 1rem;

      &::after {
        content: none;
      }
    }

    .avatar__dropdown:not(.mini-avatar) {
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      padding: 0.375rem 1.8rem 0.375rem 1rem;
      text-overflow: clip;
      width: 100%;
      border-right: 8px solid $color-primary-cta;
      transition: none;

      @include media-breakpoint-up(md) {
        @include addTransition();
      }

      &.button--secondary {
        border-right: 8px solid $color-red-special;
      }

      &:hover,
      &:focus {
        border-color: $color-pink-light;
      }

      &:active {
        border-color: $color-red-dark;
      }

      &.active:not(:hover):not(:active) {
        color: $color-white;
        background-color: $color-red-dark;
        box-shadow: inset 0 0 0 0.0625rem $color-red-dark;
        fill: $color-white;
        border-color: $color-red-dark;

        &::after {
          background: linear-gradient(to left, $color-red-dark 50%, rgba($color-red-dark, 0) 100%);
          @include media-breakpoint-up(md) {
            background: transparent;
          }
        }
      }

      &::after {
        position: absolute;
        right: -0.5rem;
        content: "";
        top: 0.0625rem;
        background: linear-gradient(to left, $color-red-special 60%, rgba($color-red-special, 0) 100%);
        width: 2.05rem;
        height: 1.875rem;
        border-top-right-radius: 5rem;
        border-bottom-right-radius: 5rem;

        @include media-breakpoint-up(md) {
          background: transparent;
        }
      }

      &:hover::after,
      &:focus::after {
        background: linear-gradient(to left, $color-pink-light 60%, rgba($color-pink-light, 0) 100%);

        @include media-breakpoint-up(md) {
          background: transparent;
        }
      }

      &:active::after {
        background: linear-gradient(to left, $color-red-dark 60%, rgba($color-red-dark, 0) 100%);

        @include media-breakpoint-up(md) {
          background: transparent;
        }
      }

      .avatar-icon-wrapper .avatar--icon-arrow {
        position: absolute;
        right: -0.125rem;
        margin: 0;
        z-index: 1;
      }
    }
  }

  .avatar-dropdown-placeholder {
    position: fixed;
    box-shadow: 0 0 0.625rem rgba(0, 0, 0, 0.2);
    font-size: 0;
    z-index: 102;
    right: 0;
    left: 0;
    top: 0;
    height: 100vh;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: $color-white;
    opacity: 0;
    visibility: hidden;
    text-align: center;

    @include media-breakpoint-up(md) {
      position: absolute;
      margin-top: 0.5rem;
      max-width: 23rem;
      right: 1.25rem;
      justify-content: center;
      height: auto;
      left: 0;
      top: auto;
      min-width: 17.5rem;
    }

    .svg-icon {
      width: 3rem;
      height: 3rem;

      &.avatar--icon-close {
        width: 1.75rem;
        height: 1.75rem;
        margin: 0.75rem 1rem 0.75rem 0;
        fill: $color-grey-dark;
      }
    }

    &.active {
      opacity: 1;
      visibility: visible;
    }

    &__header {
      padding: 1.5rem 1.5rem 0.6rem;
    }

    &__top-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 0.0625rem solid $color-grey-special;
      padding: 0;
      align-items: center;

      @include media-breakpoint-up(md) {
        display: none;
      }
    }

    &__loginstate-text-info {
      @include font(text, 3, normal);

      border-bottom: 0.0625rem solid $color-grey-special;
      padding-bottom: 1.5rem;
      margin: 0;
    }

    &__heading {
      padding-left: 1.5rem;
      margin: 1rem 0;
    }

    &__lock-icon.svg-icon {
      width: 1.25rem;
      height: 1.25rem;
      fill: $color-grey-dark;
      position: absolute;
      right: -0.25rem;
      top: -0.0625rem;
      background-color: $color-white;
      border-radius: 50%;
      border: 0.125rem solid $color-white;
    }

    &__body {
      padding: 1.3rem 1rem 0;
    }

    &__footer {
      padding: 0 1.5rem 2rem;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }

    &__mini-bonus {
      @include font(text, 1, black);

      color: $color-secondary-text;
      text-transform: uppercase;
    }

    .progress-bar {
      border-radius: 0.25rem;
      height: 0.375rem;
      margin-top: 0.5rem;

      &--wrapper {
        background-color: $color-red-special;
      }

      &__filled {
        background-color: $color-red;
      }
    }

    &__discount-info {
      @include font(text, 4, light);

      margin-top: 0.375rem;
    }

    &__remaining-points {
      @include font(text, 1, normal);

      padding-bottom: 1.5rem;
      display: flex;
      border-bottom: 0.0625rem solid $color-grey-special;
      padding-right: 0.5rem;
      color: $color-grey-dark;
    }

    &__link-icons {
      @include addTransition();

      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 1.5rem;
      margin: 0;
      fill: $color-secondary-cta-text;

      &:hover {
        fill: $color-pink-light;

        .avatar-dropdown-placeholder__text {
          color: $color-pink-light;
        }
      }
    }

    &__text {
      @include font(text, 2, normal);
      @include addTransition();

      color: $color-grey-dark;
      margin-top: 0.125rem;

      //override of line hight specifically for avatar icon text
      line-height: 1rem;
    }

    &__icon-wrapper {
      position: relative;
    }

    &__logout-user {
      margin-bottom: 0.5rem;
    }
  }
}
</style>
